import { render, staticRenderFns } from "./Category01.vue?vue&type=template&id=b9f03eb8&scoped=true"
import script from "./Category01.vue?vue&type=script&lang=js"
export * from "./Category01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f03eb8",
  null
  
)

export default component.exports